"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
// Set up context with null as initial value.
// This is expected to be overwritten with actual value
// when passing value to Provider
var MenuContext = (0, preact_1.createContext)(null);
exports.default = MenuContext;
